import WithdrawHistoryPageContainer from "../../Component/Withdraw/WithdrawHistory/WithdrawHistory"

const WithdrawHistoryPage = () => {
  return (
    <div className='page-body'>
      <WithdrawHistoryPageContainer />
    </div>
  )
}

export default WithdrawHistoryPage